
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";

import { appointmentService } from "@/domain/services";
import { AppointmentModel } from "@/domain/models";
import { AppointmentBody } from "@/domain/params";
import { WeekDay, Month, RECORD_TAB } from "@/common/constants";

import hash from "object-hash";
import { parseISO } from "date-fns";

type ComponentData = {
  appointments: AppointmentModel[];
};

export default defineComponent({
  name: "PatientHistory",
  data(): ComponentData {
    return {
      appointments: [],
    };
  },
  async created() {
    appointmentService
      .load({ patient_id: this.patient_id, limit: 5000 })
      .then((appointments) => {
        this.appointments = appointments.reverse();
      });
  },
  computed: {
    ...mapState("record", ["patient_id", "appointment_id"]),
  },
  methods: {
    ...mapActions({
      setRecordAppointmentId: "record/setRecordAppointmentId",
      setRecordAppointment: "record/setRecordAppointment",
      setHashAppointment: "record/setHashAppointment",
      setActiveTab: "record/setActiveTab",
    }),
    updateAppointmentRecord(appointment: AppointmentModel) {
      const body: AppointmentBody = {};

      body.acting_id = appointment.acting_id;
      body.patient_id = appointment.patient_id;
      body.scheduled_day = parseISO(appointment.scheduled_day);

      body.complaint = appointment.complaint || "";
      body.prescription = appointment.prescription || "";
      body.start_time = appointment.start_time;
      body.end_time = appointment.end_time;

      this.setRecordAppointmentId(appointment.id)
      this.setRecordAppointment(body);
      this.setHashAppointment(hash(body));
      this.setActiveTab(RECORD_TAB.appointment)
    },
    showAppointmentDateTime(
      scheduled_day: string,
      start_time: number,
      end_time?: number
    ): string {
      let result = "";
      const scheduled_date = parseISO(scheduled_day);

      result = `${
        WeekDay[scheduled_date.getDay()]
      } ${scheduled_date.getDate()} de ${Month[scheduled_date.getMonth()][0]} `;

      if (end_time === undefined || end_time === null)
        result = result + " as " + start_time.toClockTime();
      else
        result =
          result +
          " das " +
          start_time.toClockTime() +
          " até " +
          end_time?.toClockTime();

      return result;
    },
  },
});
